import { useState } from "react";

import { readHexColor } from "../lib/settings-draft";

/**
 * 只在重挂时用得上的中性色：标签切走再切回来时，草稿里可能正躺着一串没输完的
 * Hex，这一刻没有「上一个合法值」可守。其余时候预览走的都是守住的那个值。
 */
const FALLBACK_ACCENT = "#8A8A90";

/**
 * 预览和取色器要的是一个颜色，不是商家正敲到一半的那串字符：原生取色控件装不下
 * 非法值，浏览器会静默兜底成黑色，于是界面一边说「请填一个合法的颜色」，一边
 * 已经把挂件改成了商家从没选过的颜色。这里守住上一个合法值，直到输入重新合法；
 * 丢弃草稿或外部读回配置时新合法值会推进基线。
 */
export function usePreviewColor(themeColor: string): string {
  const [appliedColor, setAppliedColor] = useState(
    () => readHexColor(themeColor) ?? FALLBACK_ACCENT,
  );
  const color = readHexColor(themeColor);
  if (color !== null && color !== appliedColor) {
    setAppliedColor(color);
  }
  return color ?? appliedColor;
}
